import { createStore } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import localforage from "localforage";
import rootReducer from "./reducers";

localforage.config({ name: "Unteach User Data" });

const persistConfig = {
  key: "root",
  storage: localforage,
  blacklist: ["temporary"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(
  persistedReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

// allow access to store for testing
window.App_Store = store;

export const persistor = persistStore(store);
